// extracted by mini-css-extract-plugin
module.exports = {"content":"content__13PUg","row__field":"row__field__2GVIC","row__label":"row__label__FadMu","row__label__descr":"row__label__descr__2WV9Q"};